import { TranslateService } from '@ngx-translate/core';
import { Component, ViewChild, OnInit } from '@angular/core';
import { MessageComponent } from '../shared/component/message/message.component';
import { ReturnMessageModel } from '../shared/model/return-message.model';
import { EmailModel } from "../shared/model/email.model";
import { EmailService } from '../shared/service/email.service';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit {

  @ViewChild(MessageComponent) message: MessageComponent;

  lastEvent: any;
  totalRecords: number;
  emails: EmailModel[] = [];
  email: EmailModel = new EmailModel();

  constructor(
    private emailService: EmailService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
  }

  lazy(e){
    let address = e.filters['address'] ? e.filters['address'].value : null;
    let user = e.filters['user.name'] ? e.filters['user.name'].value : null;
    this.lastEvent = e;
    this.emailService.getPaginated(e.first, e.rows, address, user).subscribe(emails => {
      this.emails = emails['rows'] as EmailModel[];
      this.totalRecords = emails['count'];
    });
  }

  onSelect(e){
    this.email = e.data as EmailModel;
  }
  
  onNew(){
    this.email = new EmailModel();
  }

  onSave(){
    this.emailService.save(this.email).subscribe((r: ReturnMessageModel) => {
      if (r.error){
        return this.message.error(this.translate(r.message));
      } 
      this.message.success(r.message);
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  onDelete(){
    this.emailService.delete(this.email.id).subscribe((r: ReturnMessageModel) => {
      if (r.error) this.message.error(r.message); else this.message.success(r.message);
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  validate(): boolean {
      return EmailModel.validate(this.email);
  }

  translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);


}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/email/email.component.ts